__turbopack_context__.v({
  "checkbox": "input-module-scss-module__0dD-ia__checkbox",
  "checked": "input-module-scss-module__0dD-ia__checked",
  "color": "input-module-scss-module__0dD-ia__color",
  "countrySelector": "input-module-scss-module__0dD-ia__countrySelector",
  "dateIcon": "input-module-scss-module__0dD-ia__dateIcon",
  "dateWrapper": "input-module-scss-module__0dD-ia__dateWrapper",
  "error": "input-module-scss-module__0dD-ia__error",
  "fakeCheckbox": "input-module-scss-module__0dD-ia__fakeCheckbox",
  "fakeRadio": "input-module-scss-module__0dD-ia__fakeRadio",
  "formGroup": "input-module-scss-module__0dD-ia__formGroup",
  "icon": "input-module-scss-module__0dD-ia__icon",
  "labelText": "input-module-scss-module__0dD-ia__labelText",
  "passwordEye": "input-module-scss-module__0dD-ia__passwordEye",
  "phoneInput": "input-module-scss-module__0dD-ia__phoneInput",
  "phoneInputBtn": "input-module-scss-module__0dD-ia__phoneInputBtn",
  "placeholder": "input-module-scss-module__0dD-ia__placeholder",
  "radio": "input-module-scss-module__0dD-ia__radio",
  "radioText": "input-module-scss-module__0dD-ia__radioText",
  "readonly": "input-module-scss-module__0dD-ia__readonly",
  "success": "input-module-scss-module__0dD-ia__success",
  "upload": "input-module-scss-module__0dD-ia__upload",
});
